import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { RadioButton } from "ui/RadioButton";
import Select, {
  SelectOptionType,
  SelectRef,
} from "app/component/select/Select";
import { useSelector, useDispatch } from "react-redux";
import {
  updateExpenseType,
  updateBusinessGoal,
  loaderLock,
  loaderUnlock,
} from "store/common/actions";
import {
  formatter,
  nameFormatter,
  NameFormats,
  getNextKey,
  toDate,
  returnDateWithoutUTC,
  dateEquals,
} from "app/utils";
import CityAutocomplete, {
  CityAutocompleteOptionType,
} from "../../autocomplete/CityAutocomplete";
import { updateDetailedAO } from "store/report/actions";
import { IAO } from "infrastructure/interfaces";
import SelectExpense from "../../select-expense/SelectExpense";
import { showErrors, showInfo } from "store/exception/actions";
import Config, { ConfigTypes } from "services/ConfigService";
import _, { get } from "lodash";
import Validator from "../../validator/Validator";
import { OCCUPATION_ROLE_TYPE } from "infrastructure/enum/user-role.enum";
import EmployeeAutocomplete, {
  EmployeeAutocompleteOptionType,
} from "../../autocomplete/EmployeeAutocomplete";
import { RouteComponentProps, withRouter } from "react-router";
import { RoadObj } from "../Road";
import If from "../../util/If";
import moment from "moment";
import analitiks from "services/AnaliticsService";
import SvgIcon from "../../svg-icon/SvgIcon";
import InputChoose, { InputChooseItem } from "../../inputchoose/InputChoose";
import {
  getAdvanceReportApplication,
  getCommonBusinessGoals,
  getCommonExpenseTypes,
  getCommonUserDetail,
} from "../../../../store/selectors";
import {
  deleteExpensesById,
  getAssistancesById,
  getFieldPermissionsCreateAdvanceReportApplications,
  getFieldPermissionsUpdateAdvanceReportApplications,
  getOccupationsShortByEmployeeId,
  postAdvanceReportApplications,
  updateAdvanceReportApplicationsByIdWithParams,
  updatePerDiemCalculations,
  getPerDiemRecalculationBusinessGoals,
  postCustomPropertyValuesByObject,
  updateCustomPropertyValues,
  checkPerDiemAODuplicates,
} from "../../../../services/ApiService";
import { Button } from "ui/Button";
import CalendarComponent from "../../calendar/calendarComponent";
import CreateDocumentModal from "./CreateDocumentModal";
import CreateDocumentLayout from "./CreateDocumentLayout";
import {
  getValues,
  validateAllocation,
  validateRequiredCustomProperties,
  validateRoad,
} from "./utils";
import { FormProvider, useForm } from "react-hook-form";
import { ICustomField } from "app/component/custom-property/types";
import { getObjectLogicalId } from "app/component/custom-property/utility";

interface CreateAOModalProps extends RouteComponentProps<any> {
  isOpen: boolean;
  onClose: (isSimpleClose?: boolean) => void;
  editId?: number;
  hasNext?: boolean;
}

const CreateAOModal: React.FC<CreateAOModalProps> = (props) => {
  let { t, i18n } = useTranslation();

  const expenseTypes = useSelector(getCommonExpenseTypes);
  const businessGoalOptions = useSelector(getCommonBusinessGoals);
  const advanceReportDetail: IAO = useSelector(getAdvanceReportApplication);
  const userDetail = useSelector(getCommonUserDetail);

  const dispatch = useDispatch();

  const [hideBusinessGoal, setHideBusinessGoal] = useState(false);

  const [editMode, setEditMode] = useState(false);
  const [multiRoadMode, setMultiRoadMode] = useState(false);

  const [expenseType, setExpenseType] = useState(3);

  const [expenseTypeCode, setExpenseTypeCode] = useState("General");
  const [description, setDescription] = useState("");
  const [businessGoal, setBusinessGoal] = useState<SelectOptionType | null>(
    null
  );
  const [businessGoalOnlyOne, setBusinessGoalOnlyOne] = useState(false);
  const [expenseApplication, setExpenseApplication] = useState({} as any);
  const [withExpense, setWithExpense] = useState(true);
  const [assistance, setAssistance] = useState({ text: "", value: 0 });
  const [responsible, setResponsible] = useState({ text: "", value: 0 });
  const [employeeAutocompleteReadOnly, setEmployeeAutocompleteReadOnly] =
    useState(false);
  const [isShowDailyRenew, setShowDailyRenew] = useState(false);
  const [assistanceOptions, setAssistantOptions] = useState(
    [] as SelectOptionType[]
  );
  const [responsibleOccupation, setResponsibleOccupation] =
    useState<SelectOptionType>();
  const [responsibleOccupationOptions, setResponsibleOccupationOptions] =
    useState([] as SelectOptionType[]);
  const [creatorOccupationOptions, setOccupationOptions] = useState(
    [] as SelectOptionType[]
  );

  const [selectedOccupation, setSelectedOccupation] = useState<any>();
  const [assigneeDetail, setAssigneeDetail] = useState({
    userId: 0,
    occupationId: 0,
    companyId: 0,
  });
  const [editPermissions, setEditPermissions] = useState([] as string[]);
  const [createPermissions, setCreatePermissions] = useState([] as string[]);
  const [readPermissions, setReadPermissions] = useState([] as string[]);
  const [isTabIndexDisabled, setTabIndexDisabled] = useState(false);
  const [startDate, setStartDate] = useState(null as any);
  const [endDate, setEndDate] = useState(null as any);
  const [isOpenToCalendar, setOpenToCalendar] = useState(false);
  const [isOpenBackCalendar, setOpenBackCalendar] = useState(false);
  const [options, setOptions] = useState([] as InputChooseItem[]);
  const [filterParams, setFilterParams] = useState({} as any);
  const [roads, setRoads] = useState([] as RoadObj[]);
  const [isBusinessGoalChange, setBusinessGoalChange] = useState(false);
  const [recalculationBusinessGoal, setRecalculationBusinessGoals] = useState(
    [] as number[]
  );
  const [isSelectOccupation, setSelectOccupation] = useState(false);

  const descriptionRef = useRef({} as HTMLInputElement);
  const businessGoalRef = useRef<SelectRef>({} as SelectRef);
  const assistanceRef = useRef<SelectRef>({} as SelectRef);
  const creatorOccupationRef = useRef<SelectRef>({} as SelectRef);
  const dataRef = useRef({} as any);

  const expenseValidator = useRef({} as any);
  const businessGoalValidator = useRef({} as any);
  const responsibleValidatorRef = useRef({} as any);
  const assistanceValidatorRef = useRef({} as any);
  const creatorOccupationValidatorRef = useRef({} as any);
  const responsibleOccupationRef = useRef({} as any);

  const [employee, setEmployee] = useState(
    {} as EmployeeAutocompleteOptionType
  );
  const employeeAutocompleteRef = useRef({} as any);
  const cityAutocompleteRef = useRef({} as any);

  const arrayExpenseTypes = useRef<Array<any>>();

  const displayTime = Config.getConfigToCompany(
    ConfigTypes.DISPLAY_BUSINESS_TRIP_START_AND_END_TIME,
    advanceReportDetail && advanceReportDetail?.company
      ? advanceReportDetail?.company?.id
      : selectedOccupation?.company
        ? selectedOccupation?.company?.id
        : ""
  );
  const methods = useForm<{ customFields: ICustomField[] }>();

  useEffect(() => {
    if (editMode) {
      const businessTargetIdDefault: number = advanceReportDetail
        ? advanceReportDetail.businessTarget.id
        : -1;

      if (recalculationBusinessGoal.includes(businessTargetIdDefault)) {
        businessGoal && recalculationBusinessGoal.includes(+businessGoal.value)
          ? setBusinessGoalChange(false)
          : setBusinessGoalChange(true);
      } else {
        businessGoal && !recalculationBusinessGoal.includes(+businessGoal.value)
          ? setBusinessGoalChange(false)
          : setBusinessGoalChange(true);
      }
    }
  }, [
    advanceReportDetail,
    businessGoal,
    editMode,
    isBusinessGoalChange,
    recalculationBusinessGoal,
  ]);

  const init = async () => {
    setSelectedOccupation({} as any);
    setWithExpense(true);
    setAssistantOptions([]);
    setResponsibleOccupationOptions([]);
    setStartDate(null);
    setEndDate(null);
    setOptions([]);
    setEmployee({} as EmployeeAutocompleteOptionType);
    if (props.editId) {
      await initEditMode(props.editId);
      await setInitialValues();
      if (advanceReportDetail && advanceReportDetail.properties) {
        setReadPermissions(advanceReportDetail.properties);
      }
    } else {
      if (userDetail.occupations.length <= 1) {
        await initClearMode();
        setAssigneeDetail({
          userId: userDetail.id,
          occupationId: userDetail.occupations[0].occupationId,
          companyId: userDetail.occupations[0].company.id,
        });
        await dispatch(updateExpenseType(userDetail.occupations[0].company.id));
      }
    }
    await initOccupationOptions(userDetail.occupations);
  };

  useEffect(() => {
    if (props.isOpen) {
      init();
    } else {
      setFilterParams({
        Status: ["3", "6"],
        EmployeeId: userDetail.id,
        CreatedAdvanceReportApplication: false,
      });
    }
  }, [props.isOpen]);

  useEffect(() => {
    if (hideBusinessGoal && !businessGoal && !editMode) {
      dispatch(updateBusinessGoal(expenseType));
    }
  }, [hideBusinessGoal, expenseType]);

  useEffect(() => {
    props.isOpen && checkBusinessGoalVisibillity();
  }, [selectedOccupation, props.isOpen]);

  const checkBusinessGoalVisibillity = () => {
    const id =
      selectedOccupation && selectedOccupation.company
        ? selectedOccupation.company.id
        : advanceReportDetail && advanceReportDetail.company
          ? advanceReportDetail.company.id
          : 0;
    const isVisible = Config.getConfigToCompany(
      ConfigTypes.HIDE_BUSINESS_TARGET,
      id
    );
    setHideBusinessGoal(isVisible);
  };

  useEffect(() => {
    if (!editMode) {
      setRoads([
        {
          id: getNextKey("road"),
          departureFromCityId: 0,
          departureFromCityName: "",
          arrivalToCityId: 0,
          arrivalToCityName: "",
          startOn: null as any,
          endOn: null as any,
          validate: false,
          initRoad: true,
        },
      ] as RoadObj[]);
    }

    if (!withExpense && userDetail.occupations.length <= 1 && !editMode) {
      creatorOccupationtChooseHandler({
        text: "",
        value: userDetail.occupations[0].occupationId,
      });
      dispatch(updateExpenseType(userDetail.occupations[0].company.id));
    }
  }, [withExpense]);

  useEffect(() => {
    getCreatePermissions();
  }, []);

  useEffect(() => {
    if (_.isEqual(expenseTypes, arrayExpenseTypes.current)) {
      return;
    }
    arrayExpenseTypes.current = expenseTypes;
    if (expenseTypes && expenseTypes.length && !props.editId) {
      const currentExpenseType =
        expenseTypes.find((type) => type.id === expenseType) ||
        expenseTypes.find((type) => type.code === "General") ||
        expenseTypes[0];
      const { id, code } = currentExpenseType;
      setExpenseType(id);
      setExpenseTypeCode(code);
      if (!hideBusinessGoal) {
        setBusinessGoal(null);
        businessGoalRef?.current?.clear?.();
      }
      dispatch(updateBusinessGoal(id));
    }
  }, [expenseTypes, props.editId]);

  useEffect(() => {
    if (!businessGoalOptions) {
      return;
    }

    if (props.isOpen) {
      let businessGoals = businessGoalOptions.map((businessGoalOption) => {
        return {
          value: businessGoalOption.id,
          text: businessGoalOption.name[i18n.language as "ru"],
        };
      });

      if (!props.editId) {
        if (businessGoals.length === 1) {
          setBusinessGoal(businessGoals[0]);
          setBusinessGoalOnlyOne(true);
        } else {
          setBusinessGoal(null);
          businessGoalRef?.current?.clear?.();
          setBusinessGoalOnlyOne(false);
        }
      }

      if (props.editId) {
        const businessTargetId = advanceReportDetail?.businessTarget?.id || -1;
        const businessTargetName =
          advanceReportDetail?.businessTarget?.name[i18n.language as "ru"] ||
          "";
        setBusinessGoal({
          value: businessTargetId,
          text: businessTargetName,
        });
      }
    }
  }, [businessGoalOptions]);

  const initClearMode = async () => {
    await getCreatePermissions();
    setEditMode(false);
    setDescription("");
    setExpenseApplication({} as any);
    setRoads([
      {
        id: getNextKey("road"),
        departureFromCityId: 0,
        departureFromCityName: "",
        arrivalToCityId: 0,
        arrivalToCityName: "",
        startOn: null as any,
        endOn: null as any,
        validate: false,
        initRoad: true,
      },
    ] as RoadObj[]);
  };

  const initEditMode = async (id: number) => {
    setEditMode(true);

    let companyId = advanceReportDetail ? advanceReportDetail.company.id : 0;
    await getRecalculationBusinessGoals(companyId, "AdvanceReportApplication");

    await getEditPermissions();
    await dispatch(updateDetailedAO(id));
    if (
      !expenseTypes ||
      expenseTypes?.length === 0 ||
      props.hasNext !== undefined
    ) {
      await dispatch(updateExpenseType(advanceReportDetail.company.id));
    }

    if (
      !businessGoalOptions ||
      businessGoalOptions?.length === 0 ||
      props.hasNext !== undefined
    ) {
      await dispatch(
        updateBusinessGoal(advanceReportDetail.applicationType.id)
      );
    }

    if (advanceReportDetail.applicationType.code === "Travel") {
      let mapEditRoads = ([] as RoadObj[])
        .concat({
          id: getNextKey("road"),
          departureFromCityId: advanceReportDetail
            ? advanceReportDetail.departureFromCityId.id
            : -1,
          departureFromCityName: advanceReportDetail
            ? advanceReportDetail.departureFromCityId.name[
                i18n.language as "ru"
              ]
            : "",
          arrivalToCityId: advanceReportDetail
            ? advanceReportDetail.businessTripDestinations.length > 0
              ? advanceReportDetail.businessTripDestinations[0].city.id
              : advanceReportDetail.arrivalToCityId.id
            : -1,
          arrivalToCityName: advanceReportDetail
            ? advanceReportDetail.businessTripDestinations.length > 0
              ? advanceReportDetail.businessTripDestinations[0].city.name[
                  i18n.language as "ru"
                ]
              : advanceReportDetail.arrivalToCityId.name[i18n.language as "ru"]
            : "",
          startOn: advanceReportDetail
            ? displayTime
              ? toDate(advanceReportDetail.localStartOn)
              : toDate(advanceReportDetail.startOn)
            : "",
          endOn: advanceReportDetail
            ? advanceReportDetail.businessTripDestinations.length > 0
              ? toDate(advanceReportDetail.businessTripDestinations[0].leaveOn)
              : displayTime
                ? toDate(advanceReportDetail.localEndOn)
                : toDate(advanceReportDetail.endOn)
            : "",
          validate: false,
        })
        .concat(
          advanceReportDetail.businessTripDestinations
            .filter((road, index) => {
              return index != 0;
            })
            .map((road, roadIndex) => {
              return {
                id: getNextKey("road"),
                departureFromCityId: -1,
                departureFromCityName: "",
                arrivalToCityId: road.city.id,
                arrivalToCityName: road.city.name[i18n.language as "ru"],
                startOn: toDate(road.arrivalOn),
                endOn:
                  roadIndex ===
                  advanceReportDetail.businessTripDestinations.length - 2
                    ? toDate(advanceReportDetail.localEndOn)
                    : toDate(road.leaveOn),
                validate: false,
              };
            })
        );

      setMultiRoadMode(mapEditRoads.length > 1);
      setRoads(mapEditRoads);
    }
    setEmployeeAutocompleteReadOnly(true);
    setAssistance({
      text: nameFormatter(
        advanceReportDetail.assigneeEmployee.name,
        NameFormats.FULL,
        i18n.language
      ),
      value: advanceReportDetail.assigneeEmployee.id,
    });
  };

  const getEditPermissions = async () => {
    let result = await getFieldPermissionsUpdateAdvanceReportApplications(
      advanceReportDetail ? advanceReportDetail.id : 0
    );
    if (result.headers.success) {
      let permissions = result.data;
      setEditPermissions(permissions);
    }
  };

  const getRecalculationBusinessGoals = async (
    companyId: number,
    objectTypeId: string
  ) => {
    let result = await getPerDiemRecalculationBusinessGoals(companyId);
    if (result.headers.success) {
      let recalculationBusinessGoals = result.data
        .filter(
          (item: { objectTypeId: string }) => item.objectTypeId === objectTypeId
        )
        .map((item: { valueInt: number }) => item.valueInt);
      setRecalculationBusinessGoals(recalculationBusinessGoals);
    }
  };

  const getCreatePermissions = async () => {
    let result = await getFieldPermissionsCreateAdvanceReportApplications();
    if (result.headers.success) {
      let permissions = result.data;
      setCreatePermissions(permissions);
    }
  };

  const initOccupationOptions = (data: any) => {
    let newOccupationOptions = [] as SelectOptionType[];
    let occupationOptions = data.map((item: any) => {
      return {
        occupationId: item.occupationId ? item.occupationId : item.id,
        company: item.company.name[i18n.language as "ru" | "en"], //get(item.company.name., `company.name.${}`)
        code: item.code,
        name: item.name[i18n.language as "ru" | "en"],
      };
    });
    occupationOptions.forEach((item: any) => {
      newOccupationOptions.push({
        value: item.occupationId,
        text: `${item.company} - ${item.name}`,
      });
    });
    setOccupationOptions(newOccupationOptions);
  };

  const isAssistantManagerOccupation = (): boolean => {
    if (!selectedOccupation?.occupationId) {
      return false;
    }
    let occupations = selectedOccupation?.roles.map((role: any) => role.code);
    return occupations.includes(OCCUPATION_ROLE_TYPE.ASSISTANT_MANAGER);
  };

  const setInitialValues = async () => {
    if (advanceReportDetail) {
      setWithExpense(false);
      if (!!advanceReportDetail.expenseApplication.id) {
        setExpenseApplication({
          value: advanceReportDetail.expenseApplication.id,
          text: `№${advanceReportDetail.expenseApplication.id} (${
            advanceReportDetail.applicationType.name[
              i18n.language as "en" | "ru"
            ]
          }) от ${formatter(
            "DD.MM.YYYY",
            i18n.language,
            advanceReportDetail.createdAt
          )}, ${nameFormatter(
            advanceReportDetail.createdByEmployee.name,
            NameFormats.NAME_WITH_LASTNAME,
            i18n.language
          )}`,
        });
      }
      setExpenseType(advanceReportDetail.applicationType.id);
      setExpenseTypeCode(advanceReportDetail.applicationType.code);
      setAssigneeDetail({
        userId: advanceReportDetail?.assigneeEmployee.id,
        occupationId: advanceReportDetail?.assigneeEmployee.occupationId,
        companyId: advanceReportDetail?.company?.id,
      });
      setDescription(advanceReportDetail.description);

      if (advanceReportDetail.applicationType.code === "Travel") {
        let mapEditRoads = ([] as RoadObj[])
          .concat({
            id: getNextKey("road"),
            departureFromCityId: advanceReportDetail
              ? advanceReportDetail.departureFromCityId.id
              : -1,
            departureFromCityName: advanceReportDetail
              ? advanceReportDetail.departureFromCityId.name[
                  i18n.language as "ru"
                ]
              : "",
            arrivalToCityId: advanceReportDetail
              ? advanceReportDetail.businessTripDestinations.length > 0
                ? advanceReportDetail.businessTripDestinations[0].city.id
                : advanceReportDetail.arrivalToCityId.id
              : -1,
            arrivalToCityName: advanceReportDetail
              ? advanceReportDetail.businessTripDestinations.length > 0
                ? advanceReportDetail.businessTripDestinations[0].city.name[
                    i18n.language as "ru"
                  ]
                : advanceReportDetail.arrivalToCityId.name[
                    i18n.language as "ru"
                  ]
              : "",
            startOn: advanceReportDetail ? advanceReportDetail.startOn : "",
            endOn: advanceReportDetail
              ? advanceReportDetail.businessTripDestinations.length > 0
                ? advanceReportDetail.businessTripDestinations[0].leaveOn
                : advanceReportDetail.endOn
              : "",
            validate: false,
          })
          .concat(
            advanceReportDetail.businessTripDestinations
              .filter((road, index) => {
                return index != 0;
              })
              .map((road) => {
                return {
                  id: getNextKey("road"),
                  departureFromCityId: -1,
                  departureFromCityName: "",
                  arrivalToCityId: road.city.id,
                  arrivalToCityName: road.city.name[i18n.language as "ru"],
                  startOn: road.arrivalOn,
                  endOn: road.leaveOn,
                  validate: false,
                };
              })
          );

        setMultiRoadMode(mapEditRoads.length > 1);
        setRoads(mapEditRoads);
      }
    }
  };

  const changeDescription = () => {
    setDescription(descriptionRef.current.value);
  };

  const isCoordinatorOccupation = (): boolean => {
    if (!selectedOccupation?.occupationId) {
      return false;
    }
    let occupations = selectedOccupation?.roles.map((role: any) => role.code);
    return occupations.includes(OCCUPATION_ROLE_TYPE.COORDINATOR);
  };

  const initAssistantOptions = async (occupationId: number) => {
    dispatch(loaderLock());
    let newAssistantOptions = [] as SelectOptionType[];

    let selectedOccupation = userDetail.occupations.find(
      (item) => item.occupationId == occupationId
    );

    let selectedOccupationName = selectedOccupation
      ? selectedOccupation?.name[i18n.language as "ru"]
      : "";
    let selectedOccupationCompany = selectedOccupation
      ? selectedOccupation?.company.name[i18n.language as "ru"]
      : "";

    setAssigneeDetail({
      userId: userDetail.id,
      occupationId: selectedOccupation ? selectedOccupation?.occupationId : 0,
      companyId: selectedOccupation ? selectedOccupation?.company.id : 0,
    });

    let response = await getAssistancesById(occupationId);
    if (response.headers.success) {
      let assistanceList = response.data.value.assistances.map((item: any) => {
        return {
          name: {
            ru: get(item, "employeeName.ru", ""),
            en: get(item, "employeeName.en", ""),
          },
          employeeOccupationName: {
            ru: get(item, "employeeOccupationName.ru", ""),
            en: get(item, "employeeOccupationName.en", ""),
          },
          company: {
            id: get(item, "company.id", 0),
            name: {
              ru: get(item, "company.name.ru", ""),
              en: get(item, "company.name.en", ""),
            },
          },
          employeeOccupationId: get(item, "employeeOccupationId", ""),
          employeeId: get(item, "employeeId", 0),
        };
      });
      if (assistanceList.length > 0) {
        newAssistantOptions.push({
          value: occupationId,
          text: `${
            userDetail.name[i18n.language as "ru"]
          } - ${selectedOccupationCompany} - ${selectedOccupationName}`,
          detail: {
            name: get(selectedOccupation, "employee.name", { ru: "", en: "" }),
            employeeOccupationName: get(selectedOccupation, "name", {
              ru: "",
              en: "",
            }),
            company: {
              id: get(selectedOccupation, "company.id", 0),
              name: get(selectedOccupation, "company.name", { ru: "", en: "" }),
            },
            employeeOccupationId: get(selectedOccupation, "occupationId", 0),
            employeeId: userDetail.id,
          },
        } as any);
        assistanceList.forEach((item: any) => {
          newAssistantOptions.push({
            value: item.employeeId,
            text: `${item.name[i18n.language as "ru"]} - ${
              item.company.name[i18n.language as "ru"]
            } - ${item.employeeOccupationName[i18n.language as "ru"]}`,
            detail: item,
          } as any);
        });
      }
    } else {
      dispatch(
        showErrors({
          code: "del_substituation",
          message: "Не удалось загрузить сотрудников",
        })
      );
    }
    setAssistantOptions(newAssistantOptions);
    if (
      newAssistantOptions.length > 0 &&
      !isAssistantManagerOccupation() &&
      !isCoordinatorOccupation()
    ) {
      setAssistance({
        value: occupationId,
        text: `${
          userDetail.name[i18n.language as "ru"]
        } - ${selectedOccupationCompany} - ${selectedOccupationName}`,
      });
    }
    dispatch(loaderUnlock());
  };

  const creatorOccupationtChooseHandler = async (option: any) => {
    setSelectOccupation(true);
    if (!hideBusinessGoal) {
      setBusinessGoal(null);
      businessGoalRef?.current?.clear?.();
    }
    let selectedOccupation = userDetail.occupations.find(
      (item) => item.occupationId == option.value
    );
    setSelectedOccupation(selectedOccupation);
    setResponsibleOccupationOptions([]);
    let companyId = selectedOccupation ? selectedOccupation?.company.id : 0;
    let occupationId = selectedOccupation
      ? selectedOccupation?.occupationId
      : 0;

    setAssigneeDetail({
      userId: userDetail.id,
      occupationId: occupationId,
      companyId: companyId,
    });
    await dispatch(updateExpenseType(companyId));
    initAssistantOptions(occupationId);
  };

  const assistanceChooseHandler = async (option: any) => {
    setAssistance(option);
    setAssigneeDetail({
      userId: option.detail.employeeId,
      occupationId: option.detail.employeeOccupationId,
      companyId: option.detail.company.id,
    });
    await dispatch(updateExpenseType(option.detail.company.id));
    await initClearMode();
  };

  const responsibleChooseHandler = async (
    option: EmployeeAutocompleteOptionType
  ) => {

    setAssistance(option);

    if (option && option.value) {
      dispatch(loaderLock);
      let result = await getOccupationsShortByEmployeeId(
        option.value,
        assigneeDetail.companyId
      );

      if (result.headers.success) {
        let newOption = result.data.map((item: any) => {
          return {
            text: `${get(item, `company.name.${i18n.language}`, "")} - ${get(
              item,
              `name.${i18n.language}`,
              ""
            )}`,
            value: get(item, "id", 0),
            detail: {
              companyId: get(item, "company.id", 0),
            },
          };
        });

        setResponsibleOccupationOptions(newOption);
        setResponsibleOccupation(newOption[0]);
        setAssigneeDetail({
          userId: option.value,
          occupationId: newOption?.at(0)?.value,
          companyId: newOption?.at(0).detail?.companyId,
        });
        await dispatch(updateExpenseType(newOption[0]?.detail?.companyId));
      } else {
        dispatch(
          showErrors({
            code: "expense_applications_error",
            message: "Не удалось получить список назначений",
          })
        );
      }
      dispatch(loaderUnlock);
    }
  };

  const responsibleOccupationChooseHandler = async (option: any) => {
    setResponsibleOccupation(option);
    setAssigneeDetail({
      userId: assigneeDetail.userId,
      occupationId: option.value,
      companyId: option.detail.companyId,
    });
    await dispatch(updateExpenseType(option.detail.companyId));
  };

  const typeRadioClickHandler = (id: number) => {
    setExpenseType(+id);
    if (!hideBusinessGoal) {
      setBusinessGoal(null);
      businessGoalRef?.current?.clear?.();
    }
    expenseTypes.forEach((expense) => {
      if (expense.id === id) {
        setExpenseTypeCode(expense.code);
        dispatch(updateBusinessGoal(id));
      }
    });
  };

  const businessGoalChooseHandler = (option: SelectOptionType) => {
    setBusinessGoal(option);
  };

  const changeRoads = (roads: RoadObj[]) => {
    setRoads(roads);
  };

  const closeHandler = () => {
    props.onClose(true);
    setSelectOccupation(false);
  };

  const validate = (): boolean => {
    let isValid = true;
    let validateList = withExpense
      ? [expenseValidator.current.validate()]
      : [businessGoalValidator.current.validate()];
    if (!withExpense && creatorOccupationOptions.length > 1 && !editMode) {
      validateList.push(
        ...validateList,
        creatorOccupationValidatorRef.current.validate()
      );
    }
    if (!withExpense && isCoordinatorOccupation()) {
      validateList = [
        ...validateList,
        responsibleValidatorRef.current.validate(),
      ];
    }
    if (
      !withExpense &&
      assistanceOptions.length > 0 &&
      !isAssistantManagerOccupation() &&
      !isCoordinatorOccupation()
    ) {
      validateList = [
        ...validateList,
        assistanceValidatorRef.current.validate(),
      ];
    }
    if (!withExpense && expenseTypeCode === "Travel") {
      setRoadValidation(true);
      roads.forEach((road, index) => {
        if (!validateRoad(road, index, multiRoadMode)) {
          isValid = false;
        }
      });
    }
    validateList.forEach((item) => {
      if (!item) {
        isValid = false;
        return;
      }
    });

    const [valid, sum, text] = validateAllocation(methods);
    if (!valid && text) {
      isValid = false;
      dispatch(
        showErrors({
          code: "",
          message: t(String(text), { percent: sum }),
        })
      );
      dispatch(loaderUnlock());
    }
    if (!withExpense) {
      const isValidCustomFields = validateRequiredCustomProperties(
        methods,
        !!props.editId
      );
      if (!isValidCustomFields) {
        isValid = false;
      }
    }
    return isValid;
  };

  const setRoadValidation = (validate: boolean) => {
    let newRoads: RoadObj[] = roads.map((road) => {
      road.validate = validate;
      return road;
    });
    setRoads(newRoads);
  };

  const saveHandler = async () => {
    if (!validate()) {
      return;
    }

    if (editMode) {
      await edit();
    } else {
      await create();
    }
    setRoadValidation(false);

    if (
      isBusinessGoalChange &&
      advanceReportDetail.expenses.filter(
        (expense) => expense.expenseType.groupCode === "Perdiem"
      ).length > 0
    ) {
      setShowDailyRenew(isBusinessGoalChange);
      dailyRenew();
    }
  };

  const editSubmit = async (data: any) => {
    dispatch(loaderLock());
    let perDiemCalculationType = Config.getConfigToCompany(
      ConfigTypes.PERDIEM_CALCULATION_TYPE,
      assigneeDetail.companyId
    );

    try {
      let needRenew = false;

      if (
        perDiemCalculationType != 0 &&
        advanceReportDetail.expenses.filter(
          (item) => item.expenseType.expenseGroup.code == "Perdiem"
        ).length > 0
      ) {
        if (
          data.businessTripOption &&
          !dateEquals(
            data.businessTripOption.startOn,
            advanceReportDetail.startOn
          )
        ) {
          needRenew = true;
        }
        if (
          data.businessTripOption &&
          !dateEquals(data.businessTripOption.endOn, advanceReportDetail.endOn)
        ) {
          needRenew = true;
        }

        if (
          data.businessTripOption &&
          data.businessTripOption.departureFromCityId !=
            advanceReportDetail.departureFromCityId.id
        ) {
          needRenew = true;
        }
        if (
          data.businessTripOption &&
          data.businessTripOption.arrivalToCityId !=
            advanceReportDetail.arrivalToCityId.id
        ) {
          needRenew = true;
        }

        let oldTrip = advanceReportDetail.businessTripDestinations;
        let newTrip = data.businessTripOption
          ? data.businessTripOption.businessTripDestination
            ? data.businessTripOption.businessTripDestination
            : []
          : [];
        if (oldTrip.length == newTrip.length) {
          oldTrip.sort((a, b) => a.ordinal - b.ordinal);
          newTrip.sort((a: any, b: any) => a.ordinal - b.ordinal);

          for (let index = 0; index < oldTrip.length; index++) {
            const oldElement = oldTrip[index];
            const newElement = newTrip[index];
            if (oldElement.city.id != newElement.cityId) {
              needRenew = true;
            }
            if (!dateEquals(oldElement.leaveOn, newElement.leaveOn)) {
              needRenew = true;
            }
            if (!dateEquals(oldElement.arrivalOn, newElement.arrivalOn)) {
              needRenew = true;
            }
          }
        } else {
          needRenew = true;
        }
      }
      validateAllocation(methods);
      await updateAdvanceReportApplicationsByIdWithParams(props.editId, data);
      await updateCustomPropertyValues({
        companyId: data?.company?.id,
        externalObjectId: props?.editId,
        objectLogicalNameId: await getObjectLogicalId({ isAO: true }),
        valueItems: getValues(methods, true),
      });
      props.editId && (await dispatch(updateDetailedAO(props.editId)));

      if (needRenew) {
        await dailyRenew();
      }
      analitiks("EditingAO", {
        aoId: props.editId,
        occupationId: get(
          userDetail.occupations.find(
            (occupation) => occupation.company.id === data.companyId
          ) || userDetail.occupations[0],
          "occupationId"
        ),
        companyId: data.companyId,
        employeeId: userDetail.id,
      });
      if (!needRenew) {
        props.onClose(false);
      }
    } catch (e) {
      console.log(e);
      dispatch(
        showErrors({
          code: "edit_report",
          message: "Не удалось отредактировать отчет",
        })
      );
    }
    dispatch(loaderUnlock());
  };

  useEffect(() => {
    if (businessGoal) {
      dataRef.current.businessTargetId = +businessGoal.value;
    }
  }, [businessGoal]);

  useEffect(() => {
    dataRef.current.journeyNumber =
      advanceReportDetail.journey && advanceReportDetail.journey.journeyNumber;
    dataRef.current.businessTripNumber =
      advanceReportDetail.journey &&
      advanceReportDetail.journey.businessTripNumber;
    dataRef.current.advanceCashAmount =
      advanceReportDetail && advanceReportDetail.advanceCashAmount;
    dataRef.current.totalAmount =
      advanceReportDetail && advanceReportDetail.totalAmount;
    dataRef.current.companyId =
      advanceReportDetail &&
      advanceReportDetail.company &&
      advanceReportDetail.company.id;
  }, [advanceReportDetail]);

  useEffect(() => {
    dataRef.current.description = description;
  }, [description]);

  useEffect(() => {
    dataRef.current.applicationTypeId = expenseType;
  }, [expenseType]);

  useEffect(() => {
    dataRef.current.assigneeEmployeeId =
      assigneeDetail && assigneeDetail.userId;
  }, [assigneeDetail]);

  useEffect(() => {
    if (expenseTypeCode === "Travel") {
      let dayNumber = (date: Date) => {
        return +moment(date).format("YYYYMMDD");
      };
      let applicationTravelDates =
        advanceReportDetail &&
        advanceReportDetail.applicationTravelDates &&
        advanceReportDetail.applicationTravelDates.filter((item) => {
          if (dayNumber(roads[0].startOn) > dayNumber(item.startDate)) {
            return false;
          }
          return (
            dayNumber(roads[roads.length - 1].endOn) >= dayNumber(item.endDate)
          );
        });
      const businessTripOptionWithTime = displayTime
        ? {
            localStartOn:
              roads[0] && roads[0].startOn
                ? returnDateWithoutUTC(roads[0].startOn, true)
                : null,
            localEndOn:
              roads[roads.length - 1] && roads[roads.length - 1].endOn
                ? returnDateWithoutUTC(roads[roads.length - 1].endOn, true)
                : null,
          }
        : {};
      dataRef.current.businessTripOption = {
        ...businessTripOptionWithTime,
        departureFromCityId: roads[0] ? roads[0].departureFromCityId : null,
        startOn:
          roads[0] && roads[0].startOn
            ? returnDateWithoutUTC(roads[0].startOn, true)
            : null,
        arrivalToCityId: roads[roads.length - 1]
          ? roads[roads.length - 1].arrivalToCityId
          : null,
        endOn:
          roads[roads.length - 1] && roads[roads.length - 1].endOn
            ? returnDateWithoutUTC(roads[roads.length - 1].endOn, true)
            : null,
        personalDaysNumber:
          advanceReportDetail && advanceReportDetail.personalDaysNumber,
        applicationTravelDates: applicationTravelDates,
      };
      if (roads.length > 0) {
        dataRef.current.businessTripOption.businessTripDestination = roads.map(
          (road, index) => {
            const isLast = index === roads.length - 1;
            const middleEndHours = isLast ? undefined : 23;
            const middleEndMinutes = isLast ? undefined : 59;
            const time = displayTime
              ? {
                  localArrivalOn:
                    road && road.startOn
                      ? returnDateWithoutUTC(road.startOn, true)
                      : null,
                  localLeaveOn:
                    road && road.endOn
                      ? returnDateWithoutUTC(
                          road.endOn,
                          true,
                          middleEndHours,
                          middleEndMinutes
                        )
                      : null,
                }
              : {};
            return {
              ...time,
              cityId: road ? road.arrivalToCityId : null,
              arrivalOn:
                road && road.startOn
                  ? returnDateWithoutUTC(road.startOn, displayTime)
                  : null,
              leaveOn:
                road && road.endOn
                  ? returnDateWithoutUTC(
                      road.endOn,
                      displayTime,
                      middleEndHours,
                      middleEndMinutes
                    )
                  : null,
              ordinal: index + 1,
            };
          }
        );
      }
    }
    if (expenseTypeCode !== "Travel") {
      delete dataRef.current.businessTripOption;
    }
  }, [roads, expenseTypeCode]);

  const edit = async () => {
    if (editMode && withExpense) {
      props.onClose(true);
      return;
    }
    editSubmit(dataRef.current);
  };

  const checkPerDiems = Config.getConfigToCompany(
    ConfigTypes.CHECK_PER_DIEM_DUPLICATES,
    advanceReportDetail?.company
      ? advanceReportDetail?.company?.id
      : selectedOccupation?.company
        ? selectedOccupation?.company?.id
        : ""
  );

  const saveSubmit = async (data: any) => {
    dispatch(loaderLock());
    let response = await postAdvanceReportApplications(
      withExpense ? expenseApplication.value.id : "",
      !withExpense ? data : null
    );

    if (response.headers.success) {
      if (checkPerDiems && withExpense) {
        try {
          const duplicate = await checkPerDiemAODuplicates(
            { companyId: response.data.company.id },
            response.data.id
          );
          if (duplicate && duplicate.data && duplicate.data.length > 0) {
            dispatch(
              showInfo({
                code: "duplicate_expense",
                message: t(
                  "modals.create_advance_report_modal.foundDuplicates",
                  {
                    name: duplicate.data[0]
                      ? duplicate.data[0].expenseName[
                          i18n.language as "ru" | "en"
                        ]
                      : "",
                    duplicates: `${duplicate.data
                      .map(
                        (el: any) =>
                          `${el.employeeFullName.lastName[(i18n.language as "ru") || "en"]} ${el.employeeFullName.firstName[(i18n.language as "ru") || "en"].slice(0, 1)}. ${el.employeeFullName.middleName[(i18n.language as "ru") || "en"].slice(0, 1)}., <a href="./#/AdvanceReportApplication/Detail/${el.id}">${el.id}</a>, ${formatter(
                            "DD.MM.YYYY",
                            i18n.language,
                            el.startOn,
                            el.endOn,
                            { withMonth: true, withYear: false }
                          )}`
                      )
                      .join("<br /> ")}`,
                  }
                ),
              })
            );
          }
        } catch (e) {
          console.log(e);
        }
      }
      if (!withExpense) {
        await postCustomPropertyValuesByObject({
          companyId: response.data.company.id,
          externalObjectId: response.data.id,
          objectLogicalNameId: await getObjectLogicalId({ isAO: true }),
          valueItems: getValues(methods),
        });
      }
      analitiks("SaveFormCreateAO", {
        aoId: response.data.id,
        type: response.data.applicationType.id,
        employeeId: userDetail.id,
        occupationId: get(
          userDetail.occupations.find(
            (occupation) => occupation.company.id === response.data.company.id
          ) || userDetail.occupations[0],
          "occupationId"
        ),
        companyId: response.data.company.id,
      });
      props.history.push(
        `/AdvanceReportApplication/Detail/${response.data.id}`
      );
      props.onClose(false);
    } else {
      switch (response.status) {
        case 400:
          dispatch(
            showErrors({
              code: "save_advance_report",
              message: JSON.stringify(response.data),
            })
          );
          break;
        default:
          dispatch(
            showErrors({
              code: "save_advance_report",
              message: "Не удалось создать авансовый отчет",
            })
          );
          break;
      }
    }
    dispatch(loaderUnlock());
  };

  const create = () => {
    saveSubmit({
      ...dataRef.current,
      occupationId: +assigneeDetail.occupationId,
    });
  };

  const advanceReportTypeChooseHandler = (id: number) => {
    setSelectOccupation(false);
    if (id === 1) {
      setWithExpense(true);
    } else {
      setWithExpense(false);
    }
  };

  const expenseApplicationOnChooseHandler = (value: any) => {
    setExpenseApplication(value);
  };

  const changeRoadMode = () => {
    let newRoads = [] as RoadObj[];
    newRoads.push({
      id: getNextKey("road"),
      departureFromCityId: roads[0].departureFromCityId,
      departureFromCityName: roads[0].departureFromCityName,
      arrivalToCityId: roads[0].arrivalToCityId,
      arrivalToCityName: roads[0].arrivalToCityName,
      startOn: roads[0].startOn,
      endOn: roads[0].endOn,
      validate: roads[0].validate,
    });
    if (!multiRoadMode) {
      newRoads.push({
        id: getNextKey("road"),
        departureFromCityId: 0,
        departureFromCityName: "",
        arrivalToCityId: 0,
        arrivalToCityName: "",
        startOn: null as any,
        endOn: null as any,
        validate: false,
      });
    }
    setRoads(newRoads);
    setMultiRoadMode(!multiRoadMode);
  };

  const dailyRenew = async () => {
    dispatch(loaderLock());
    let a = advanceReportDetail
      ? advanceReportDetail.expenses
          .filter((item: any) => {
            return item.expenseType.expenseGroup.code == "Perdiem";
          })
          .map((item: any) => item.id)
      : [];

    for (let index = 0; index < a.length; index++) {
      const element = a[index];
      await deleteExpensesById(element);
    }

    let data = {
      applicationRef: {
        id: advanceReportDetail ? advanceReportDetail.id : 0,
        logicalName: "AdvanceReportApplication",
        name: {
          ru: "AdvanceReportApplication",
          en: "AdvanceReportApplication",
        },
      },
      calculations: [],
    };
    await updatePerDiemCalculations(data);
    props.editId && (await dispatch(updateDetailedAO(props.editId)));
    dispatch(loaderUnlock());
    openDailyRenew();
  };

  const openDailyRenew = () => {
    setShowDailyRenew(true);
  };

  const closeDailyRenew = () => {
    setShowDailyRenew(false);
	props.onClose(true);
  };

  const employeeChooseHandler = (option: EmployeeAutocompleteOptionType) => {
    setEmployee(option);
  };

  const onSelectedToDate = (value: any) => {
    setStartDate(value);
    setOpenToCalendar(false);
  };

  const onClickToCalendar = () => {
    setOpenToCalendar(!isOpenToCalendar);
  };

  const onClickBackCalendar = () => {
    setOpenBackCalendar(!isOpenBackCalendar);
  };

  const onSelectedBackDate = (value: any) => {
    setEndDate(value);
    setOpenBackCalendar(false);
  };

  const onCityChooseHandler = (option: CityAutocompleteOptionType) => {
    cityAutocompleteRef.current.clear();
    let cityOptions: InputChooseItem[] = [...options];
    let index = cityOptions.findIndex((city) => city.value === option.value);
    if (index === -1) {
      cityOptions.push(option);
      setOptions(cityOptions);
    }
  };

  const onCityDeleteHandler = (option: InputChooseItem) => {
    let cityOptions: InputChooseItem[] = [...options];
    cityOptions.splice(
      cityOptions.findIndex((city) => city.value === option.value),
      1
    );
    setOptions(cityOptions);
  };

  const searchZNRHandler = () => {
    setFilterParams({
      Status: ["3", "6"],
      EmployeeId: employee.value,
      StartOn: startDate || null,
      EndOn: endDate || null,
      CityId: [...options.map((option) => option.value)],
      CreatedAdvanceReportApplication: false,
    });
  };

  const isHighestModal = (isHighest: boolean) => {
    setTabIndexDisabled(!isHighest);
  };

  if (!props.isOpen) {
    return null;
  }

  return (
    <CreateDocumentLayout
      isOpen={props.isOpen}
      isHighestModal={isHighestModal}
      saveHandler={saveHandler}
	  editId={props.editId}
	  isAdvance={true}
      closeHandler={closeHandler}
      title={
        editMode
          ? t("modals.create_advance_report_modal.edit_application")
          : t("modals.create_advance_report_modal.create_application")
      }
      isShowDailyRenew={isShowDailyRenew}
      closeDailyRenew={closeDailyRenew}
    >
      <FormProvider {...methods}>
        <div className="box-modal-form">
          <div className="box-modal-form-block">
            <div className="box-modal-checkbox-wrap m-b-15">
              <RadioButton
                checked={
                  editMode
                    ? !!advanceReportDetail.expenseApplication.id
                    : withExpense
                }
                label={t(
                  "modals.create_advance_report_modal.based_on_application_for_expense"
                )}
                onClick={
                  !editMode
                    ? () => {
                        advanceReportTypeChooseHandler(1);
                      }
                    : () => {}
                }
                id={1}
                name={"radoii"}
                key={1}
                disabled={editMode}
              />
              <RadioButton
                checked={
                  editMode
                    ? !advanceReportDetail.expenseApplication.id
                    : !withExpense
                }
                label={t(
                  "modals.create_advance_report_modal.no_application_for_expense"
                )}
                onClick={
                  !editMode
                    ? () => {
                        advanceReportTypeChooseHandler(2);
                      }
                    : () => {}
                }
                id={2}
                name={"radoii"}
                key={2}
                disabled={editMode}
              />
            </div>
            <If condition={!editMode && !withExpense}>
              {creatorOccupationOptions.length > 1 ? (
                <Validator
                  type={"select"}
                  ref={creatorOccupationValidatorRef}
                  errorMessage={t("create_expense.select_occupation")}
                >
                  <React.Fragment>
                    <label className="input-label">
                      {t("create_expense.select_occupation")}
                      <i className="input-required">*</i>
                    </label>
                    <Select
                      ref={creatorOccupationRef}
                      options={creatorOccupationOptions}
                      onChoose={creatorOccupationtChooseHandler}
                      defaultText={t("create_expense.select_occupation")}
                      disabled={!!props.editId}
                    />
                  </React.Fragment>
                </Validator>
              ) : null}
            </If>
            {withExpense ? (
              <>
                <Validator
                  style={{ marginTop: "18px" }}
                  ref={expenseValidator}
                  type={"select"}
                >
                  <div style={{ marginRight: "-12px" }}>
                    <SelectExpense
                      filterParams={filterParams}
                      readOnly={props.editId ? withExpense : false}
                      onChoose={expenseApplicationOnChooseHandler}
                      defaultValue={editMode ? expenseApplication : null}
                      defaultText={t(
                        "modals.create_advance_report_modal.select_request_for_expense"
                      )}
                    />
                  </div>
                </Validator>

                <>
                  <div
                    className={`input-item-row znr-search-row ${
                      editMode ? "d-none" : ""
                    }`}
                    style={{ alignItems: "flex-end" }}
                  >
                    <div className="input-item znr-by-business-trip">
                      <label className="input-label">
                        {t(
                          "modals.create_advance_report_modal.search_by_business_trip_date"
                        )}
                      </label>
                    </div>
                    <div className="input-item znr-by-cities">
                      <label className="input-label">
                        {t(
                          "modals.create_advance_report_modal.search_by_cities"
                        )}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`input-item-row znr-search-row ${
                      editMode ? "d-none" : ""
                    }`}
                  >
                    <div
                      className="input-item"
                      style={{ alignSelf: "baseline" }}
                    >
                      <div
                        className={`input-picker-wrap input-date ${
                          startDate ? "active" : ""
                        }`}
                      >
                        <input
                          value={
                            startDate
                              ? formatter("D MMMM", i18n.language, startDate)
                              : ""
                          }
                          onClick={onClickToCalendar}
                          className="input datepicker pointer"
                          type="text"
                          id="datepicker"
                          placeholder={t("filters.one_way")}
                          readOnly={true}
                        />
                        <SvgIcon
                          className={"icon icon-calendar"}
                          href={"#svg_icon_calendar"}
                          onClick={onClickToCalendar}
                        />
                      </div>
                      <CalendarComponent
                        startDate={startDate}
                        isShown={isOpenToCalendar}
                        onSelected={onSelectedToDate}
                        isMultiChoice={false}
                        disableAfterDate={endDate}
                        onClose={() => setOpenToCalendar(false)}
                      />
                    </div>
                    <div
                      className="input-item"
                      style={{ alignSelf: "baseline" }}
                    >
                      <div
                        className={`input-picker-wrap input-date ${
                          endDate ? "active" : ""
                        }`}
                      >
                        <input
                          value={
                            endDate
                              ? formatter("D MMMM", i18n.language, endDate)
                              : ""
                          }
                          onClick={onClickBackCalendar}
                          className="input datepicker pointer"
                          type="text"
                          id="datepicker_2"
                          placeholder={t("filters.back")}
                          readOnly={true}
                        />
                        <SvgIcon
                          onClick={onClickBackCalendar}
                          className={"icon icon-calendar"}
                          href={"#svg_icon_calendar"}
                        />
                      </div>
                      <CalendarComponent
                        startDate={endDate}
                        isShown={isOpenBackCalendar}
                        onSelected={onSelectedBackDate}
                        isMultiChoice={false}
                        disableBeforeDate={startDate}
                        onClose={() => setOpenBackCalendar(false)}
                      />
                    </div>
                    <div className="input-item">
                      <label className="input-label znr-by-cities-mob">
                        {t(
                          "modals.create_advance_report_modal.search_by_cities"
                        )}
                      </label>
                      <CityAutocomplete
                        ref={cityAutocompleteRef}
                        onChoose={onCityChooseHandler}
                        placeholder={t("filters.city")}
                      />
                      <InputChoose
                        options={options}
                        onDelete={onCityDeleteHandler}
                      />
                    </div>
                  </div>
                  <div
                    className={`input-item-row znr-search-row ${
                      editMode ? "d-none" : ""
                    }`}
                  >
                    <div className="input-item znr-by-employee">
                      <label className="input-label">
                        {t(
                          "modals.create_advance_report_modal.search_by_employee"
                        )}
                      </label>
                      <div className="input-search">
                        <EmployeeAutocomplete
                          ref={employeeAutocompleteRef}
                          onChoose={employeeChooseHandler}
                          placeholder={t("filters.enter_name")}
                          tabIndex={isTabIndexDisabled ? -1 : 0}
                        />
                      </div>
                    </div>
                    <Button
                      onClick={searchZNRHandler}
                      buttonColor="gray"
                      buttonText={t(
                        "modals.create_advance_report_modal.search"
                      )}
                      big
                    />
                  </div>
                </>
              </>
            ) : null}
            {editMode && !!advanceReportDetail.expenseApplication.id ? (
              <div className="box-modal-form-block disabled">
                <Validator ref={expenseValidator} type={"select"}>
                  <SelectExpense
                    readOnly={true}
                    defaultValue={editMode ? expenseApplication : null}
                    defaultText={t(
                      "modals.create_advance_report_modal.select_request_for_expense"
                    )}
                  />
                </Validator>
              </div>
            ) : null}
          </div>
        </div>
        <CreateDocumentModal
          showTime={displayTime}
          editMode={editMode}
          isSelectOccupation={isSelectOccupation}
          creatorOccupationOptions={creatorOccupationOptions}
          expenseTypes={expenseTypes}
          expenseType={expenseType}
          typeRadioClickHandler={typeRadioClickHandler}
          expenseTypeCode={expenseTypeCode}
          roads={roads}
          changeRoads={changeRoads}
          changeRoadMode={changeRoadMode}
          multiRoadMode={multiRoadMode}
          isTabIndexDisabled={isTabIndexDisabled}
          assistanceOptions={assistanceOptions}
          isAssistantManagerOccupation={isAssistantManagerOccupation}
          isCoordinatorOccupation={isCoordinatorOccupation}
          assistanceValidatorRef={assistanceValidatorRef}
          assistanceRef={assistanceRef}
          assistance={assistance}
          assistanceChooseHandler={assistanceChooseHandler}
          props={props}
          responsibleValidatorRef={responsibleValidatorRef}
          responsibleChooseHandler={responsibleChooseHandler}
          employeeAutocompleteReadOnly={employeeAutocompleteReadOnly}
          responsibleOccupationOptions={responsibleOccupationOptions}
          responsibleOccupationRef={responsibleOccupationRef}
          responsibleOccupation={responsibleOccupation}
          responsibleOccupationChooseHandler={
            responsibleOccupationChooseHandler
          }
          businessGoal={businessGoal}
          businessGoalValidatorRef={businessGoalValidator}
          hideBusinessGoal={hideBusinessGoal}
          businessGoalRef={businessGoalRef}
          businessGoalOnlyOne={businessGoalOnlyOne}
          businessGoalOptions={businessGoalOptions}
          businessGoalChooseHandler={businessGoalChooseHandler}
          descriptionRef={descriptionRef}
          description={description}
          changeDescription={changeDescription}
          dataRef={dataRef}
          editPermissions={editPermissions}
          createPermissions={createPermissions}
          readPermissions={readPermissions}
          assigneeDetail={assigneeDetail}
          aoProps={{
            responsible,
            advanceReportDetail,
          }}
        />
      </FormProvider>
    </CreateDocumentLayout>
  );
};

export default withRouter(CreateAOModal);
